import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=47f84bac&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f84bac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47f84bac')) {
      api.createRecord('47f84bac', component.options)
    } else {
      api.reload('47f84bac', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=47f84bac&scoped=true&", function () {
      api.rerender('47f84bac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2v3U4B2qSjxGw/JS/comp/Voucher-Unit.vue"
export default component.exports